<div [formGroup]="billingSourceForm" class="admin-dialog__section">
  <div class="form-label">
    <span class="form-label__text form-label__text--section" i18n="@@adminSystem.distributorDetails.label.billingSource">決済情報</span>
  </div>

  <div [formGroup]="billingSourceForm" class="admin-dialog__section">
    <div class="admin-dialog__field-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label i18n="@@adminSystem.distributorDetails.label.paymentMethod">支払い方法</mat-label>
        <mat-select formControlName="paymentMethod" (selectionChange)="onPaymentMethodChange($event.value)">
          @for (item of paymentMethods; track item.code) {
            <mat-option [value]="item.code">{{ item.desc }}</mat-option>
          }
        </mat-select>
        @if (billingSourceForm.get('paymentMethod')?.hasError('required')) {
          <mat-error i18n="@@adminSystem.distributorDetails.error.required">必須項目です</mat-error>
        }
      </mat-form-field>
    </div>

    @if (billingSourceForm.get('paymentMethod')?.value === 'Invoice') {
      <div formGroupName="invoiceInfo" class="nested-form-section">
        <div class="role-checkboxes">
          <label class="role-checkbox">

            <mat-checkbox formControlName="useMainAddress" (change)="onUseMainAddressChange($event.checked)"></mat-checkbox>
            <span class="role-checkbox__label" i18n="@@adminSystem.distributorDetails.label.useMainAddress">メインの住所を請求先として使用する</span>
          </label>
        </div>

        @if (!billingSourceForm.get('invoiceInfo')?.get('useMainAddress')?.value) {
          <div class="nested-address-box">
            <app-addresses-form [addressesForm]="invoiceAddressesGroup"></app-addresses-form>
          </div>
        }

        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.billToPersonName">請求先宛名</mat-label>
            <input matInput formControlName="billToPersonName" />
          </mat-form-field>
        </div>
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.billToEmailAddresses">請求先メールアドレス（複数のときはセミコロンで区切る）</mat-label>
            <input matInput formControlName="billToEmailAddresses" />
          </mat-form-field>
        </div>
      </div>
    }

    @if (billingSourceForm.get('paymentMethod')?.value === 'CreditCard') {
      <div formGroupName="creditCardInfo" class="nested-form-section">
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label i18n="@@adminSystem.distributorDetails.label.creditCardToken">クレジットカードトークン</mat-label>
            <input matInput formControlName="creditCardToken" />
          </mat-form-field>
        </div>
      </div>
    }

    @if (billingSourceForm.get('paymentMethod')?.value === 'DirectDebit') {
      <div formGroupName="directDebitInfo" class="nested-form-section">
        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.bankName">金融機関名</mat-label>
            <input matInput formControlName="bankName" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.branchName">支店名</mat-label>
            <input matInput formControlName="branchName" />
          </mat-form-field>
        </div>

        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.accountType">預金種目 (普通/当座など)</mat-label>
            <input matInput formControlName="accountType" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.accountNumber">口座番号</mat-label>
            <input matInput formControlName="accountNumber" />
          </mat-form-field>
        </div>

        <div class="admin-dialog__field-row">
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.accountHolderName">口座名義 (カナ)</mat-label>
            <input matInput formControlName="accountHolderName" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field form-field--half">
            <mat-label i18n="@@adminSystem.distributorDetails.label.last4">口座番号下4桁</mat-label>
            <input matInput formControlName="last4" readonly />
          </mat-form-field>
        </div>
      </div>
    }
  </div>

</div>